var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewAccount = function SvgNewAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.99a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.75 6.99a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11 6.99a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11.75 18.99h1.5v-3h3v-1.5h-3v-3h-1.5v3h-3v1.5h3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.24H5a2.25 2.25 0 0 0-2.25 2.25v17.25h19.5V5.49A2.25 2.25 0 0 0 20 3.24m.75 18H4.25v-12h16.5zM4.25 7.74V5.49A.75.75 0 0 1 5 4.74h15a.75.75 0 0 1 .75.75v2.25z"
  })));
};
export default SvgNewAccount;